import { Stack } from "@mui/material";
import strings from "global/constants/StringConstants";
import CenteredAuthenticatedLayout from "layouts/CenteredAuthenticated/CenteredAuthenticatedLayout";
import { ChangeEvent, useCallback, useState } from "react";
import MySignRequestsConfigurations from "./components/MySignRequestsConfigurations";
import SentRequestsFolderView from "./components/SentRequestsFolderView";
import SharedWithMeView from "./components/SharedWithMeView";
import InboxView from "./Inbox/InboxView";
import Unauthorized from "screens/Shared/Unauthorized";
import { hasAccessTo, isAdmin } from "layouts/Config";
import history from "utils/history";
import { useTitle } from "utils/UseTitle";
import title from "global/constants/TitleConstants";

const MySignRequests = (props: any) => {
  const [currentTab, setCurrentTab] = useState(
    props.requestType || strings.sentRequest,
  );
  // WCAG 2.4.2: name the list the page shows. The inbox view sets its own.
  useTitle(currentTab === strings.sentRequest ? title.SENT : title.SIGN_REQUEST);
  const [loader, setLoader] = useState<boolean>(false);

  const hasMyRequestsFetchPermission = hasAccessTo(
    strings.resources.sign,
    strings.fetchPermission,
  );

  const isRequestsTab = [
    strings.inboxRequest,
    strings.sentRequest,
    strings.sharedRequest,
  ].includes(currentTab);
  const isConfigTab = currentTab === strings.configurations;
  const isInboxTab = currentTab === strings.inboxRequest;
  const isSharedTab = currentTab === strings.sharedRequest;

  const canViewRequests = hasMyRequestsFetchPermission;
  const canViewConfigurations = isAdmin();

  const hasPermission =
    (isRequestsTab && canViewRequests) ||
    (isConfigTab && canViewConfigurations);

  const permissionDenied = isRequestsTab ? canViewRequests : isAdmin();

  const handleTabsChange = useCallback(
    (event: ChangeEvent<any>, value: string): void => {
      setCurrentTab(value);
      const path =
        value === strings.configurations
          ? "/requests/settings"
          : `/requests/${value}`;
      history.push(path);
    },
    [history, strings.configurations],
  );

  if (!hasPermission) {
    return <Unauthorized permissionDenied={permissionDenied} />;
  }

  const renderTab = () => {
    if (isConfigTab) {
      return (
        <Stack direction="column" spacing={1}>
          <MySignRequestsConfigurations />
        </Stack>
      );
    }
    if (isInboxTab) {
      return <InboxView />;
    }
    if (isSharedTab) {
      return <SharedWithMeView />;
    }
    return <SentRequestsFolderView loader={loader} setLoader={setLoader} />;
  };

  // Inbox, Sent and Configurations all sit on the shared centred column, the
  // same wrapper Templates uses; each screen adds only its own inner padding.
  return (
    <CenteredAuthenticatedLayout>{renderTab()}</CenteredAuthenticatedLayout>
  );
};

export default MySignRequests;
